import React from 'react'
import Button from 'components/Button/Button'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import {
  ProgramListButtonContainer,
  ProgramListItemActions,
  ProgramListItemText,
} from './ProgramList.styled'
import { ProgramListItemProps } from './ProgramList.props'

export default function ProgramListItem({
  onEdit,
  program,
}: ProgramListItemProps) {
  return (
    <TableItemContainer>
      <TableItemBody>
        <ProgramListItemText>{program.name}</ProgramListItemText>
      </TableItemBody>
      {/* <TableItemBody></TableItemBody>
      <TableItemBody></TableItemBody>
      <TableItemBody></TableItemBody> */}
      <TableItemBody>
        <ProgramListItemActions>
          <ProgramListButtonContainer>
            <Button
              preset={'ghost'}
              variant={'primary'}
              text={'List Signups'}
              size={'small'}
            />
          </ProgramListButtonContainer>
          <ProgramListButtonContainer>
            <Button
              preset={'ghost'}
              variant={'primary'}
              text={'Edit Details'}
              size={'small'}
              onClick={() => onEdit('1')}
            />
          </ProgramListButtonContainer>
          <ProgramListButtonContainer>
            <Button
              style={{ border: '2px solid' }}
              preset={'ghost'}
              variant={'secondary'}
              text={'Delete Program'}
              size={'small'}
            />
          </ProgramListButtonContainer>
        </ProgramListItemActions>
      </TableItemBody>

      {/* <TableItemBody>
          <ClientListItemActions>
            <img src={DotsIcon} alt="dots icon" />
            <Button
              preset={'ghost'}
              variant={'primary'}
              text={'Profile'}
              size={'tiny'}
            />
          </ClientListItemActions>
        </TableItemBody> */}
    </TableItemContainer>
  )
}
